import React from 'react';
import { Button, Modal, Message, ToastContext } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import css from '../../chart-list.module.css';

export default function DeleteModal({ inventory, inventories, chartId, organization, onClose, open, sync }) {
    const { t } = useTranslation();
    const toast = React.useContext(ToastContext);
    const [isDeleting, setIsDeleting] = React.useState(false);

    const cannotDelete = React.useMemo(() => {
        let sub_inventories_list = [];

        if (!inventory.virtual) {
            return inventory.has_active_bookings;
        }

        inventory.sub_inventories?.forEach(si => {
            sub_inventories_list.push(inventories?.find(iv => iv.uuid === si));
        });

        return sub_inventories_list?.some(iv => iv && iv.has_active_bookings);
    }, [inventory, inventories]);

    const inventoryToDelete = React.useMemo(() => {
        const cannotDelete = inventory.has_active_bookings;
        return {
            type: cannotDelete ? 'danger' : 'warning',
            message: t(`ticket.charts.inventory.deleteModal.${cannotDelete ? 'denied' : 'warning'}`)
        };
    }, [inventory, cannotDelete]);

    const handleDelete = React.useCallback(() => {
        setIsDeleting(true);
        inventory
            .delete({
                organizationId: organization.id,
                chartId
            })
            .then(() => {
                toast.success(t('ticket.charts.inventory.delete_success'));
            })
            .catch(e => {
                console.error(e);
                if (e.response[0] === 'Cannot delete inventory: Active bookings exist for this inventory.') {
                    toast.error(t(`ticket.charts.inventory.deleteModal.denied`));
                } else {
                    toast.error(t('ticket.charts.inventory.delete_error'));
                }
            })
            .finally(() => {
                setIsDeleting(false);
                sync();
            });
    }, [inventory, organization, toast, chartId, sync]);

    return (
        <Modal
            allowExternalClosing={false}
            open={open}
            onClose={() => onClose(false)}
            submitButton={<Button primary label={t('ticket.common.action.delete')} onClick={handleDelete} disabled={cannotDelete} isLoading={isDeleting} />}
            cancelButton={<Button onClick={() => onClose(false)} label={t('ticket.common.action.cancel')} disabled={isDeleting} />}
            title={t('ticket.charts.inventory.deleteModal.title')}
        >
            <div className={css['inventories-modal-message']}>
                <Message type={inventoryToDelete.type}>{inventoryToDelete.message}</Message>
                {!cannotDelete && t('ticket.charts.inventory.deleteModal.description')}
            </div>
        </Modal>
    );
}
